import ShareIcon from '@mui/icons-material/Share';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Skeleton from '@mui/material/Skeleton';
import { Breakpoint } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useBreakpoint } from '@/utils/useBreakpoint';

import { shareProfileStyles as sx } from './Share.styles';
import { ShareModal } from './ShareModal';

type Props = {
	buttonText?: string;
	title: string;
	description: string;
	collapseAt?: Breakpoint;
	loading?: boolean;
	variant?: 'contained' | 'outlined';
};

export const Share = ({
	buttonText,
	title,
	description,
	collapseAt,
	loading,
	variant = 'contained'
}: Props) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const isCollapsed = useBreakpoint(collapseAt ?? 'md', 'down');

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	if (loading) {
		return isCollapsed ? (
			<Skeleton animation={false} width={28} height={28} variant='circular' />
		) : (
			<Skeleton animation={false} width={130} />
		);
	}

	return (
		<>
			{isCollapsed ? (
				<Tooltip title={buttonText ?? t('Share')}>
					<IconButton onClick={handleOpen} color='primary' size='small'>
						<ShareIcon fontSize='inherit' />
					</IconButton>
				</Tooltip>
			) : (
				<Button
					sx={sx.root}
					variant={variant}
					startIcon={<ShareIcon />}
					onClick={handleOpen}
				>
					{buttonText ?? t('Share')}
				</Button>
			)}

			<ShareModal
				open={open}
				onClose={handleClose}
				title={title}
				description={description}
			/>
		</>
	);
};
